/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import template from './segment-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserProfile} from '../../components/session/local-user-profile';

@Component({
  standalone: false,
  selector: 'adn-segment-list-page',
  template
})
export class SegmentListPageComponent extends AdminResourceListPageBase implements OnInit {
  readonly itemStateName = 'app.dat-seg.segments.segment';

  mode = 2;
  columns: AdminListColumn[] = [];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserProfile) private readonly localUserProfile: any
  ) {
    super(LocalNetworkProfile);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.mode = this.localUserProfile.getCurrentApp() === 'ADVERTISING' ? 2 : 1;
    this.columns = this.mode === 2
      ? [{param: 'name'}, {param: 'type'}, {labelInstant: 'Publisher', param: '', sortable: false}]
      : [
        {param: 'name'},
        {label: 'label', param: '', sortable: false},
        {label: 'members', param: '', sortable: false},
        {label: 'folders', param: '', sortable: false}
      ];
  }
}
